"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sendMessage_1 = require("../../actions/chats/sendMessage");
const userTyping_1 = require("../../actions/chats/userTyping");
const chatFunctions = __importStar(require("../model/chats"));
const RtcConnectionsHandler_1 = __importDefault(require("./RtcConnectionsHandler"));
const markMessagesAsRead_1 = require("../../actions/chats/markMessagesAsRead");
const webRtcMiddleware = store => next => event => {
    switch (event.type) {
        case markMessagesAsRead_1.MARK_MESSAGES_AS_READ: {
            const { chatId, messageIds } = event.payload;
            const [chat] = chatFunctions.getChat(store.getState().chatsState.chats, chatId);
            if (chatFunctions.isDirectChat(chat)) {
                const p2pMessage = {
                    kind: markMessagesAsRead_1.MARK_MESSAGES_AS_READ_REMOTELY,
                    messageIds
                };
                sendMessage(p2pMessage, chat);
            }
            break;
        }
        case markMessagesAsRead_1.MARK_MESSAGES_AS_READ_BY_CLIENT_ID: {
            const { chatId, clientMessageIds } = event.payload;
            const [chat] = chatFunctions.getChat(store.getState().chatsState.chats, chatId);
            if (chatFunctions.isDirectChat(chat)) {
                const p2pMessage = {
                    kind: markMessagesAsRead_1.MARK_MESSAGES_AS_READ_BY_CLIENT_ID_REMOTELY,
                    clientMessageIds
                };
                sendMessage(p2pMessage, chat);
            }
            break;
        }
        case sendMessage_1.SEND_MESSAGE_REQUESTED: {
            const { chat, clientMessageId, content } = event.payload;
            if (content.kind === "text" && chatFunctions.isConfirmedChat(chat)) {
                const p2pMessage = {
                    kind: sendMessage_1.SEND_MESSAGE_REQUESTED,
                    chatId: chat.chatId,
                    clientMessageId,
                    content
                };
                sendMessage(p2pMessage, chat);
            }
            break;
        }
        case userTyping_1.CURRENT_USER_TYPING: {
            const chatId = event.payload;
            const [chat] = chatFunctions.getChat(store.getState().chatsState.chats, chatId);
            if (chatFunctions.isDirectChat(chat)) {
                const blockedUsers = store.getState().chatsState.blockedUsers;
                if (blockedUsers.includes(chat.them)) {
                    break;
                }
            }
            const p2pMessage = {
                kind: userTyping_1.REMOTE_USER_TYPING,
                chatId: chat.chatId
            };
            sendMessage(p2pMessage, chat);
            break;
        }
        case userTyping_1.CURRENT_USER_STOPPED_TYPING: {
            const chatId = event.payload;
            const [chat] = chatFunctions.getChat(store.getState().chatsState.chats, chatId);
            const p2pMessage = {
                kind: userTyping_1.REMOTE_USER_STOPPED_TYPING,
                chatId: chat.chatId
            };
            sendMessage(p2pMessage, chat);
            break;
        }
    }
    return next(event);
};
exports.default = webRtcMiddleware;
function sendMessage(message, chat) {
    const users = chatFunctions.getUsers(chat);
    RtcConnectionsHandler_1.default.sendMessage(users, JSON.stringify(message));
}
